import { IconBuildingFactory2 } from "@tabler/icons-react";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { MantineIconCell } from "../../../../../mantine/mrt/components/cell/MantineIconCell";
import type { Person } from "../../../../../utils/backend-types";
import type { Contract } from "../../../DeliveryOverview.types";

export function getSupplierColumn(
  contracts: Array<Contract>,
  persons: Array<Person>
): MRT_ColumnDef<Contract> {
  const usedSupplierIds = contracts.map((contract) => contract.supplier);
  const sortedUsedSuppliers = persons
    .filter((person) => usedSupplierIds.includes(person.id))
    .map((person) => person.name)
    .sort((personA, personB) => personA.localeCompare(personB));
  const usedSuppliersSet = Array.from<string>(new Set(sortedUsedSuppliers));
  const uniqueUsedSuppliers = Array.from(usedSuppliersSet);

  return {
    accessorKey: "supplier",
    accessorFn: (row) => {
      return persons.find((person) => person.id === row.supplier)?.name || "";
    },
    header: "Lieferant",
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: {
      data: uniqueUsedSuppliers
    },
    Cell: (props) => (
      <MantineIconCell {...props} IconComponent={IconBuildingFactory2} />
    )
  };
}
